<div class="container fx-layout-row-wrap">
	<div *ngFor="let voice of voices; index as i" class="fx-flex-17-5 fx-flex-lt-lg-30 fx-flex-lt-md-47-5" style="margin-left: 2%; height: 25%;">
		<app-custom-card
		[id]="i"
		[text]="voices[i]"
		[icon]="icons[i]"
		(click)="this.goTo($event)">
		</app-custom-card>
	</div>
</div>

